import React from 'react';
import { KeyboardBackspace, NavigateBefore, NavigateNext } from '@mui/icons-material'
import { Box, Button, Typography, useTheme, alpha } from '@mui/material'
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const ControlBar = (props) => {
  const { tutor } = props
  const teachers = useSelector(state => state.search.results)
  const index = teachers.findIndex(teacher => teacher._id === tutor._id)
  const navigate = useNavigate()
  const location = useLocation()
  const backToSearch = () => {
    navigate('/search' + location.search);
  }

  const theme = useTheme()
  
  return (
    <Box sx={{ 
      display: 'flex', 
      justifyContent: 'space-between', 
      alignItems: 'center',
      mb: 3,
      flexWrap: { xs: 'wrap', sm: 'nowrap' },
      gap: { xs: 2, sm: 0 }
    }}>
      <Button
        onClick={backToSearch}
        startIcon={<KeyboardBackspace />}
        sx={{
          color: theme.palette.text.secondary,
          textTransform: 'none',
          fontWeight: 500,
          minWidth: 'auto',
          px: { xs: 1, sm: 2 },
          '&:hover': {
            color: theme.palette.primary.main,
            backgroundColor: alpha(theme.palette.primary.main, 0.08)
          }
        }}
      >
        <Typography variant="body2" sx={{ 
          fontWeight: 500,
          fontSize: { xs: '0.875rem', sm: '0.9rem' },
          display: { xs: 'none', sm: 'block' }
        }}>
          Back to Search
        </Typography>
        <Typography variant="body2" sx={{ 
          fontWeight: 500,
          fontSize: '0.875rem',
          display: { xs: 'block', sm: 'none' }
        }}>
          Back
        </Typography>
      </Button>
      
      {index > -1 && (
        <Box sx={{ display: 'flex', gap: { xs: 0.5, sm: 1 } }}>
          {index > 0 && (
            <Button
              onClick={() => navigate(`/tutor/${teachers[index - 1]._id}`)}
              startIcon={<NavigateBefore sx={{ fontSize: { xs: '1rem', sm: '1.25rem' } }} />}
              variant="outlined"
              size="small"
              sx={{
                textTransform: 'none',
                fontWeight: 500,
                borderColor: theme.palette.divider,
                color: theme.palette.text.secondary,
                fontSize: { xs: '0.75rem', sm: '0.875rem' },
                px: { xs: 1, sm: 2 },
                '&:hover': {
                  borderColor: theme.palette.primary.main,
                  color: theme.palette.primary.main,
                  backgroundColor: alpha(theme.palette.primary.main, 0.08)
                }
              }}
            >
              <Box component="span" sx={{ display: { xs: 'none', sm: 'inline' } }}>
                Previous
              </Box>
              <Box component="span" sx={{ display: { xs: 'inline', sm: 'none' } }}>
                Prev
              </Box>
            </Button>
          )}
          {index < teachers.length - 1 && (
            <Button
              onClick={() => navigate(`/tutor/${teachers[index + 1]._id}`)}
              endIcon={<NavigateNext sx={{ fontSize: { xs: '1rem', sm: '1.25rem' } }} />}
              variant="outlined"
              size="small"
              sx={{
                textTransform: 'none',
                fontWeight: 500,
                borderColor: theme.palette.divider,
                color: theme.palette.text.secondary,
                fontSize: { xs: '0.75rem', sm: '0.875rem' },
                px: { xs: 1, sm: 2 },
                '&:hover': {
                  borderColor: theme.palette.primary.main,
                  color: theme.palette.primary.main,
                  backgroundColor: alpha(theme.palette.primary.main, 0.08)
                }
              }}
            >
              Next
            </Button>
          )}
        </Box>
      )}
    </Box>
  );
};

export default ControlBar;
